import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
export var EventThresholdSelectedContainer = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "flex flex--guts " + IdStyles.TournamentThresholdSelectedContainerWrapper },
        React.createElement("div", { className: "" + IdStyles.TournamentThresholdSelectedContainer }, children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/EventThresholdSelectedContainer.tsx
// module id = 2776
// module chunks = 3